import de from './Individual.de.png'
import en from './Individual.en.png'

export default { de, en }